import { ADD_USER_DROPDOWN } from '../../actions'

export const addUserDropDownReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_USER_DROPDOWN:
      return { ...state, ...action.payload }

    default:
      return state
  }
}
